import { VIDEO_VARIANTS } from '@workspace/constants';
import { imageTextMediaDimensions } from '@workspace/blocks/ImageTextBlock/imageTextBlock.variants';
import { AppVideoImage, Picture } from '@/app/common';
import type { SanityImage } from '@workspace/interfaces';

interface ImageTextMediaProps {
  isVideo?: boolean;
  video?: string;
  image?: SanityImage;
}

export function ImageTextMedia({ isVideo, video, image }: ImageTextMediaProps) {
  if (isVideo && video) {
    return <AppVideoImage video={video} variant={VIDEO_VARIANTS.VideoWithoutText} wrapperClassName="size-full" />;
  }

  return image?.url ? (
    <Picture
      image={image}
      alt={image.bynderImage?.alt || image.alt || ''}
      desktopWidth={imageTextMediaDimensions.desktopWidth}
      desktopHeight={imageTextMediaDimensions.desktopHeight}
      mobileWidth={imageTextMediaDimensions.mobileWidth}
      mobileHeight={imageTextMediaDimensions.mobileHeight}
      className="block size-full"
      imgClassName="size-full object-cover"
    />
  ) : (
    <div className="size-full bg-placeholder" />
  );
}
